export default __webpack_public_path__ + "static/media/3.fe8372b7.jpg";